import { getSettings } from '@wordpress/date';

interface TimeFormatInfo {
    is24Hour: boolean;
    timeFormat: string;
    formatType: '24' | '12';
}

/**
 * React hook to get WordPress time format settings
 *
 * @returns {TimeFormatInfo} Object containing time format information
 */
const useWordPressTimeFormat = (): TimeFormatInfo => {
    const settings = getSettings();
    const timeFormat = settings.formats.time;
    const is24Hour = /[GH]/.test(timeFormat);

    return {
        is24Hour,
        timeFormat,
        formatType: is24Hour ? '24' : '12'
    };
};

export default useWordPressTimeFormat;
